import { LocalizedResourcesService } from 'phoenix/services';
import { ShareBaseDialog } from 'sharebase/domain';
import {
	DesktopService,
	DownloadService,
	TrackingService,
	ToastService
} from 'sharebase/services';

require('./downloadDesktopDialog.styles');
const template = require('./downloadDesktopDialog.template');

export class DownloadDesktopDialog extends ShareBaseDialog {
	public static $inject = [
		'$mdDialog',
		'$sce',
		'$window',
		'pxLocalizedResourcesService',
		'sbDesktopService',
		'sbDownloadService',
		'sbTrackingService',
		'sbToastService',
		'gettextCatalog'
	];


	constructor(
		$mdDialog:ng.material.IDialogService,
		private $sce:ng.ISCEService,
		private $window:ng.IWindowService,
		private pxLocalizedResourcesService:LocalizedResourcesService,
		private sbDesktopService:DesktopService,
		private sbDownloadService:DownloadService,
		private sbTrackingService:TrackingService,
		private sbToastService:ToastService,
		private gettextCatalog:ng.gettext.gettextCatalog
	) {
		super($mdDialog, template, gettextCatalog.getString('Download Desktop'));
	}

	public learnMore() {
		this.$window.open(this.pxLocalizedResourcesService.help, '_blank');
	}

	public downloadDesktop() {
		return this.sbDesktopService
			.getDownloadUrl()
			.then(res => {
				this.sbTrackingService.trackClick('Desktop Download link clicked - Dialog');
				if (res) {
					this.sbDownloadService.downloadByUri(res)
				}
				else {
					this.sbToastService.showSimple(this.gettextCatalog.getString('There was a problem with downloading ShareBase Desktop.'));
				}
			})
			.finally(() => super.dismiss());
	}

	public open($event:ng.IAngularEvent) {
		return super.open($event);
	}
}



// WEBPACK FOOTER //
// ./src/sharebase/components/downloadDesktopDialog/downloadDesktopDialog.ts